import { render } from "./FormWysiwyg.vue?vue&type=template&id=54c1325f"
import script from "./FormWysiwyg.vue?vue&type=script&lang=js"
export * from "./FormWysiwyg.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Form/FormWysiwyg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54c1325f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54c1325f', __exports__)) {
    console.log('reload')
    api.reload('54c1325f', __exports__)
  }
  
  module.hot.accept("./FormWysiwyg.vue?vue&type=template&id=54c1325f", () => {
    console.log('re-render')
    api.rerender('54c1325f', render)
  })

}


export default __exports__